import React, { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import Marquee from "react-fast-marquee";
import { Award, Truck, ShieldCheck, Building2 } from "lucide-react";

const stats = [
  { icon: Award, value: 26, suffix: "+", label: "Years of Legacy" },
  { icon: Truck, prefix: "2", staticText: "-Day", label: "Express Delivery", isStatic: true },
  { icon: ShieldCheck, value: 100, suffix: "%", label: "Guaranteed Fulfillment" },
  { icon: Building2, value: 1000, suffix: "+", label: "Corporate Clients Handled" },
];

const companies = ["COCA-COLA", "APOLLO", "VODAFONE", "OPPO", "HONDA", "INFOEDGE", "LINKEDIN", "BMW"];

const CountUp = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const c = animate(0, value, { duration: 1.8, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setN(v) });
    return () => c.stop();
  }, [inView, value]);
  return (
    <span ref={ref}>
      {Math.round(n).toLocaleString("en-IN")}
      <span className="text-[#F3E5AB]">{suffix}</span>
    </span>
  );
};

const LegacyBar = () => {
  return (
    <section className="relative z-20 -mt-16 bg-transparent px-6 md:px-10" data-testid="legacy-bar">
      <div className="mx-auto max-w-6xl">
        {/* Glassmorphic stats banner */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="glass grid grid-cols-2 gap-y-8 rounded-2xl px-8 py-10 shadow-[0_20px_60px_rgba(0,0,0,0.4)] md:grid-cols-4 md:py-12"
        >
          {stats.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={s.label} className="flex flex-col items-center px-2 text-center" data-testid={`legacy-stat-${i}`}>
                <Icon className="mb-3 h-6 w-6 text-[#D4AF37]" strokeWidth={1.5} />
                <div className="font-serif text-4xl font-medium tracking-tight text-[#D4AF37] md:text-5xl">
                  {s.isStatic ? (
                    <span>{s.prefix}<span className="text-[#F3E5AB]">{s.staticText}</span></span>
                  ) : (
                    <CountUp value={s.value} suffix={s.suffix} />
                  )}
                </div>
                <p className="mt-2 font-sans text-xs uppercase tracking-[0.15em] text-[#A9B0C2]">{s.label}</p>
              </div>
            );
          })}
        </motion.div>
      </div>

      {/* Client logo marquee */}
      <div className="mx-auto mt-14 max-w-7xl">
        <p className="mb-6 text-center font-sans text-xs uppercase tracking-[0.3em] text-[#8B93A7]">
          Powered &amp; fulfilled by Consortium Gifts — trusted by the world&rsquo;s leading brands
        </p>
        <Marquee speed={40} gradient={false} autoFill>
          {companies.map((c, i) => (
            <span key={i} className="px-10 font-sans text-lg font-medium tracking-[0.2em] text-[#C9CEDA]/25 transition-colors duration-300 hover:text-[#D4AF37]">
              {c}
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default LegacyBar;
